module.exports = __webpack_public_path__ + "img/top_directions.ec325c40.jpg";